import { ChangeDetectionStrategy, Component, DOCUMENT, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';

import { MatIcon } from '@angular/material/icon';
import { Icons } from '../../../../../../util/Icons';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { strictEmailValidator } from '../../../../../../util/CustomValidator';

@Component({
	selector: 'pm-create-user-profile-dialog',
	imports: [
		ReactiveFormsModule,
		MatDialogContent,
		MatFormField,
		MatLabel,
		MatError,
		MatInput,
		MatDialogActions,
		MatButton,
		MatDialogTitle,
		MatSelect,
		MatOption,
		MatTooltip,
		TranslocoDirective,
		MatIcon,
		MatSuffix,
		CdkDrag,
		CdkDragHandle,
		MatIconButton,
	],
	templateUrl: './invite-user-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './invite-user-dialog.component.scss',
})
export class InviteUserDialogComponent {
	dialogRef = inject<MatDialogRef<InviteUserDialogComponent>>(MatDialogRef);
	readonly translocoService = inject(TranslocoService);
	data = inject(MAT_DIALOG_DATA);
	private document = inject<Document>(DOCUMENT);
	private fb = inject(FormBuilder);
	icons = inject(Icons);

	inviteUserForm: FormGroup;

	constructor() {
		const data = this.data;

		this.inviteUserForm = this.fb.group({
			email: [data.email, [Validators.required, strictEmailValidator]],
			firstName: ['', [Validators.required]],
			lastName: ['', [Validators.required]],
			role: [this.data.availableRoles[0], [Validators.required]],
		});
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	onSubmit(): void {
		if (this.inviteUserForm.valid) {
			this.dialogRef.close({
				profile: {
					email: this.inviteUserForm.value.email,
					firstName: this.inviteUserForm.value.firstName,
					lastName: this.inviteUserForm.value.lastName,
					sourceUrl: this.document.location.origin ?? '',
				},
				role: this.inviteUserForm.value.role,
			});
		}
	}

	get email() {
		return this.inviteUserForm.get('email');
	}

	get firstName() {
		return this.inviteUserForm.get('firstName');
	}

	get lastName() {
		return this.inviteUserForm.get('lastName');
	}

	get role() {
		return this.inviteUserForm.get('role');
	}
}
